<button (click)="toggleState()" mat-button>
  <div class="flip-container" [ngClass]="{ 'flipped': totalsSidebarState === sidebarState.FullWidth }">
    <span class="flip-item front"><fa-icon [icon]="['fas', 'arrow-left']"></fa-icon> Expand</span>
    <span class="flip-item back">Collapse <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon></span>
  </div>
</button>
